/* global theme */

/**
 * A grouped Brunch with Santa reservation in the cart (page and drawer).
 *
 * Reservation quantities are not editable line by line - that would let the
 * hidden capacity line drift out of sync with the ticket lines. Instead the
 * whole group (tickets + capacity) is removed in one /cart/update.js call.
 */
if (!customElements.get('brunch-reservation-item')) {
  class BrunchReservationItem extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
      if (!evt.target.closest('[data-brunch-remove-reservation]')) return;
      evt.preventDefault();
      this.removeReservation();
    }

    async removeReservation() {
      const keys = (this.dataset.itemKeys || '').split(',').filter((key) => key);
      if (!keys.length) return;

      const updates = {};
      keys.forEach((key) => { updates[key] = 0; });

      this.classList.add('is-removing');
      this.querySelectorAll('button').forEach((btn) => { btn.disabled = true; });

      try {
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
      } catch (error) {
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: error.message }
        }));
        // Matches the theme's own recovery from an uncertain cart state.
        window.location.reload();
      }
    }
  }

  customElements.define('brunch-reservation-item', BrunchReservationItem);
}
